<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :disabled="disabled"
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="label"
        :rules="rules"
        persistent-hint
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        @input="menu = false"
        @change="change"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="value"
      no-title
      @input="menu = false"
      @change="change"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    rules: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    change(dt) {
      this.$emit('input', dt);
    },
  },
};
</script>
